import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ReservationService } from "../../../../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../../../../services/shared/error-handler.service";
import { UserServiceService } from "../../../../services/user-service/user-service.service";
import { ClaimService } from "../../claim.service";
import { FineService } from "../../../fines-view/fine.service";
import { forkJoin } from "rxjs/observable/forkJoin";

@Component({
  selector: "app-collect-claim-form-modal",
  templateUrl: "./collect-claim-form-modal.component.html",
  styleUrls: ["./collect-claim-form-modal.component.css"],
})
export class CollectClaimFormModalComponent implements OnInit {
  @Output() onSave = new EventEmitter();

  @ViewChild("modalRef") modalRef;

  // data
  reservation_id = null;

  paymentsRef;

  // form
  isMultiple = false;
  formData;
  holding_tax_percentage;

  constructor(
    private claimService: ClaimService,
    private fineService: FineService,
    private reservationService: ReservationService,
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  ngOnInit() {}
  public open(reservation_id, claim_ids) {
    //console.log(claim_ids);
    //console.log(this.paymentsRef);
    this.reservation_id = reservation_id;
    this.paymentsRef = claim_ids;
    if (claim_ids.length > 1) {
      this.isMultiple = true;
    } else {
      this.isMultiple = false;
    }

    this.formData = {
      status: null,
      partially_method: null,
      amount_received: "",
      partially_data: "",
    };

    this.modalRef.open();
  }

  save() {
    let claimPayload: any = {
      ids: [],
      status: this.formData.status,
      holding_tax_percentage: this.holding_tax_percentage,
    };
    if (!this.isMultiple && this.formData.status == "partially-collected") {
      claimPayload.amount_received = this.formData.amount_received;
      claimPayload.partially_method = this.formData.partially_method;
      if (claimPayload.partially_method == "Bank Transaction") {
        claimPayload.partially_data = this.formData.partially_data;
      }
    }

    let finePayload = {
      ...claimPayload,
      ids: [],
      holding_tax_percentage: this.holding_tax_percentage,
    };
    //console.log(this.paymentsRef);
    this.paymentsRef.map((payment) => {
      if (payment.type === "Fine") {
        finePayload.ids.push(payment.id);
      } else if (payment.type === "Claim") {
        claimPayload.ids.push(payment.id);
      }
    });
    //console.log(claimPayload);
    let observables = [];

    if (claimPayload.ids.length) {
      observables.push(this.saveClaims(claimPayload));
    }

    if (finePayload.ids.length) {
      observables.push(this.savefines(finePayload));
    }
    forkJoin(...observables).subscribe(
      (res) => {
        this.onSave.emit();
        this.modalRef.close();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  saveClaims(payload) {
    return this.claimService.collectClaim(this.reservation_id, payload);
  }

  savefines(payload) {
    return this.fineService.collectFine(this.reservation_id, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/modals/collect-claim-form-modal/collect-claim-form-modal.component.ts